import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {DecimalPipe} from '@angular/common';
import {ResultatData} from '../shared/models/resultat-data.model';
import {Resultat} from '../shared/models/resultat.model';
import {DateService} from './date/date.service';
import {ModalService} from './modal/modal.service';
import {DinaUppgifterService} from './dina-uppgifter.service';
import {ResultatStoreService} from '../stores/resultat.store';
import {PrintService} from './print/print.service';

@Injectable({
  providedIn: 'root'
})
export class ResultatService {
  resultat: ResultatData = {
    resultatSummaDto: {
      summaInkomstSEK: 0,
      summaMaximalAvrakning: 0
    },
    resultatDtos: []
  };

  hasAterbetalningsbelopp = false;

  constructor(
    private readonly decimalPipe: DecimalPipe,
    private readonly dateService: DateService,
    private readonly modalService: ModalService,
    private readonly printService: PrintService,
    private readonly dittUnderlagService: DinaUppgifterService,
    private readonly resultatStoreService: ResultatStoreService,
    private readonly router: Router
  ) {
  }

  getResultat(): ResultatData {
    this.hasAterbetalningsbelopp = this.checkAterbetalningsbelopp(this.resultatStoreService.resultatData);
    return this.resultatStoreService.resultatData;
  }

  tranformDigitToLocaleStringWithCurrency(decimal: number, currency: string): string {
    const value = this.tranformDigitToLocaleString(decimal);
    const text = currency === null ? '' : ' ' + currency;
    return `${value}${text}`;
  }

  tranformDigitToLocaleString(decimal: number, digitInfo = '0.0-2'): string {
    return this.decimalPipe.transform(decimal, digitInfo, 'se');
  }

  isUtbetalningsDatumBeforeValutadag(utbetalningsdatum: string, valutadag: string): boolean {
    return this.dateService.isBefore(utbetalningsdatum, valutadag);
  }

  compareDate(utbetalningsdatum: string, valutadag: string): number {
    return this.dateService.compareDate(utbetalningsdatum, valutadag);
  }

  openNewCalculationModal(): void {
    this.modalService.openNewCalculation(() => {
      this.resultatStoreService.clearAll();
      this.dittUnderlagService.clearAll();
      this.hasAterbetalningsbelopp = false;
      this.router.navigateByUrl('/');
    });
  }

  print(): void {
    this.printService.print();
  }

  private checkAterbetalningsbelopp(resultat: any): boolean {
    let hasAterbetalningsbelopp = false;
    resultat.resultatDtos.forEach((item: Resultat) => {
      if (item.aterbetalningsbelopp > 0) {
        hasAterbetalningsbelopp = true;
      }
    });
    return hasAterbetalningsbelopp;
  }
}
